export const THEME_PRIMARY_MAIN_COLOR = "#48AE4D";
export const THEME_PRIMARY_TEXT_COLOR = "#ffffff";

export const SELECTED_BLUE_COLOR = "#2196f3";
export const SITE_HEADER_HEIGHT = 240; // TODO: adjust it with real height (need to use height combinations)
